import { App } from './types';

const DEFAULT_APP_ID = 'PlaceholderAPI';

export const getLabelForItem = ({ name }: App) => name;

export const filterItems = <T extends any>(
  inputValue: string | null,
  items: Array<T>,
  _getLabelForItem?: (item: T) => string,
  showEmptyList?: boolean
): T[] => {
  // In contrast to the default, we don't show unfiltered items
  if (!inputValue) {
    return [];
  }
  // NOTE: No idea what this does
  if (showEmptyList) {
    return items;
  }
  const filtered = items.filter(item =>
    _getLabelForItem!(item).toLowerCase().includes(inputValue!.toLowerCase())
  );
  // In contrast to the default, we only show up till 10 results
  return filtered.slice(0, 10);
};

export const getSelectedApp = ({
  apps,
  isLoading,
  onSelect,
  selectedApp,
}: {
  isLoading: boolean;
  apps: App[];
  onSelect: (item: App | null) => void;
  selectedApp?: App | string | null;
}): App | null => {
  if (!selectedApp) {
    return null;
  }

  // The case when pre-filled
  if (typeof selectedApp === 'string') {
    if (isLoading) {
      return {
        id: DEFAULT_APP_ID,
        name: `${selectedApp} (loading icon and name...)`,
      };
    }

    const app = apps.find(({ id }) => id === selectedApp);

    if (app) {
      // Replace the pre-filled ID by the object
      onSelect(app);

      return app;
    }

    // could be because of error or incorrect pre-fill
    return {
      id: DEFAULT_APP_ID,
      name: `${selectedApp} (could not load icon and name)`,
    };
  }

  return selectedApp;
};
